module.exports = __webpack_public_path__ + "img/03.fbedac19.jpg";